module.exports = __webpack_public_path__ + "media/unipod/second_phase_plumbing-7c6bd4c3.jpg";